// removed by extract-text-webpack-plugin
module.exports = {"contentWrapper":"contentWrapper--1Cmny","content":"content--3cSx_ contentWrapper--AHarZ","title":"title--175-a title--3f9JQ","detail":"detail--LioaV contentArea--SiMDT","mainContent":"mainContent--30qG4"};


//////////////////
// WEBPACK FOOTER
// ./screens/SplatRouter/screens/BasicPage/styles.css
// module id = 1161
// module chunks = 0